export default "__VITE_PUBLIC_ASSET__7499bf92__"